// AdminMenu.jsx
import React from "react";
import { Link } from "react-router-dom";

const palette = {
  overlayBg: "rgba(0,0,0,0.4)",
  background: "#FFFFFF", // Bianco puro
  textDark: "#333333",
  closeBtnColor: "#999",
  hoverBg: "#fef2e0", // Beige chiaro
};

export default function AdminMenu({ isOpen, onClose }) {
  return (
    <>
      {isOpen && <div style={styles.overlay} onClick={onClose} />}
      <div
        style={{
          ...styles.menuContainer,
          transform: isOpen ? "translateX(0)" : "translateX(100%)",
        }}
      >
        <button style={styles.closeButton} onClick={onClose}>
          ✕
        </button>
        <nav style={styles.nav}>
          <ul style={styles.menuList}>
            <li>
              <Link to="/admin/dashboard" style={styles.link} onClick={onClose}>
                Dashboard
              </Link>
            </li>
            <li>
              <Link to="/admin/restaurants" style={styles.link} onClick={onClose}>
                Ristoranti &amp; Menu
              </Link>
            </li>
            <li>
              <Link to="/admin/inventory" style={styles.link} onClick={onClose}>
                Inventario
              </Link>
            </li>
            <li>
              <Link to="/admin/users" style={styles.link} onClick={onClose}>
                Users
              </Link>
            </li>
            {/* Nuova voce di menu aggiunta */}
            <li>
              <Link to="/admin/costs" style={styles.link} onClick={onClose}>
                Costi
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: palette.overlayBg,
    zIndex: 999,
    transition: "opacity 0.3s ease-out",
  },
  menuContainer: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "260px",
    height: "100%",
    backgroundColor: palette.background,
    boxShadow: "rgba(0, 0, 0, 0.2) -4px 0 8px",
    borderTopLeftRadius: "12px",
    borderBottomLeftRadius: "12px",
    padding: "20px",
    zIndex: 1000,
    transition: "transform 0.3s ease-out",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "15px",
    color: palette.closeBtnColor,
    transition: "color 0.2s",
  },
  nav: {
    marginTop: "60px",
  },
  menuList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  link: {
    display: "block",
    padding: "10px 0",
    textDecoration: "none",
    color: palette.textDark,
    fontSize: "16px",
    fontWeight: "500",
    borderRadius: "6px",
    transition: "background-color 0.2s",
    // Hover (simulato per desktop):
    ":hover": {
      backgroundColor: palette.hoverBg,
    },
  },
};
